import {
  FiGithub,
  FiLinkedin,
  FiTwitter,
  FiInstagram,
  FiFacebook,
} from "react-icons/fi";

export const socialAccounts = [
  {
    id: 1,
    name: "Github",
    icon: <FiGithub />,
    link: "https://github.com/smileyismail",
  },
  {
    id: 2,
    name: "Linkedin",
    icon: <FiLinkedin />,
    link: "https://www.linkedin.com/in/smileyismail/",
  },
  {
    id: 3,
    name: "Twitter",
    icon: <FiTwitter />,
    link: "https://twitter.com/smiley__ismail",
  },
  {
    id: 4,
    name: "Instagram",
    icon: <FiInstagram />,
    link: "https://www.instagram.com/smiley__ismail/",
  },
  {
    id: 5,
    name: "Facebook",
    icon: <FiFacebook />,
    link: "https://www.facebook.com/smileyismail1437/",
  },
];
